"use client"

import { Minimize2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Minimize2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Minimize2Icon = component(Icon)({ as: Minimize2 })
